import React,{ useRef } from "react";
import { FaFacebookF, FaTiktok, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { MdEmail, MdOutlinePhoneAndroid } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import '../Css/contact.css';
import asesoraImage from '../Images/logo_investi.png';
import logoWhatsapp from "../Images/logo-whatsapp1.png";
import emailjs from "emailjs-com";
import Swal from 'sweetalert2'
function Contacto() {
  const form = useRef();
  // Función para redirigir a WhatsApp
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/51961867761', '_blank');
  };
  

  const handleSubmit = (e) => {
    e.preventDefault(); 
    let nombre = form.current.nombre.value.trim();
    let email = form.current.email.value.trim();
    let telefono = form.current.telefono.value.trim();
    let carrera = form.current.carrera.value.trim();
    let mensaje = form.current.message.value.trim();

    // Validación de campos
    if (!nombre || !email || !telefono || !carrera || !mensaje) {
      Swal.fire({
        icon: "error",
        title: "Hubo un error",
        text: "Todos los campos son obligatorios.",
      });
      return; 
    }
    // Validación de formato de correo electrónico
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      alert("Por favor, ingresa un correo electrónico válido.");
      return;
    }

    //Envío del formulario a EmailJS
    emailjs.sendForm("service_m2ropw3",   // Service ID de EmailJS
      "template_nnztv4r",  //Template ID de EmailJS
      form.current,"arcBSq3kuhU7A3jgJ")
    .then(
      (result) => {
        Swal.fire({
          title: "¡Formulario enviado correctamente!",
          text: "Nos pondremos en contacto contigo pronto.",
          icon: "success",
          draggable: true
        });
      },
      (error) => {
        Swal.fire({
          icon: "error",
          title: "Hubo un error",
          text: "No se pudo enviar el formulario. Por favor, intenta nuevamente.",
          footer: '<a href="https://wa.me/51961867761"> O ¡Escríbenos a nuestros Whatsaap!</a>'
        });
      }
    );
    form.current.nombre.value = "";
    form.current.email.value = "";
    form.current.telefono.value = "";
    form.current.carrera.value = "";
    form.current.message.value = "";
  };

  return (
    <section className="contact-container">
      <div className="fondo-imagen"></div>
      <div className="contact-content">
        <h2>Contáctanos</h2>
        <p>En INVESTÍ, te brindamos el apoyo que necesitas en cada etapa de tu tesis. Contáctanos para conocer nuestros servicios o solicitar una cotización. Nuestro equipo está listo para ofrecerte soluciones a tu medida.</p>
      </div>

      <div className="contact-items">
        {/* Sección de Información de Contacto (Izquierda) */}
        <div className="contact-items-info">
          <div className="contact-items-info-box">
            <div className="contact-items-info-box-icon"><b></b><FaLocationDot /></div>
            <div className="contact-items-info-box-text">
              <h3>Dirección</h3>
              <p>Av. Victor Raul Nro. 538, Victor Larco Herrera - San Andres V Etapa, La Libertad - Perú.</p>
            </div>
          </div>

          <div className="contact-items-info-box">
            <div className="contact-items-info-box-icon"><b></b><MdOutlinePhoneAndroid /></div>
            <div className="contact-items-info-box-text">
              <h3>Celular</h3>
              <p>+51 961 867 761</p>
            </div>
          </div>

          <div className="contact-items-info-box">
            <div className="contact-items-info-box-icon"><b></b><MdEmail /></div>
            <div className="contact-items-info-box-text">
              <h3>Correo Electrónico</h3>
              <p>bramos@investiperu.com</p>
            </div>
          </div>
          
          {/* Asesora en la sección izquierda */}
          <div className="contact-items-info-box asesora-info-box">
            <div className="asesora-container-info">
              <img 
                src={asesoraImage} 
                alt="Asesora" 
                className="asesora-image-small" 
              />
              <div className="asesora-details">
                <h3>¿Prefieres hablar directamente?</h3>
                <button 
                  type="button" 
                  className="whatsapp-button-small"
                  onClick={handleWhatsAppClick}
                >
                  <FaWhatsapp className="whatsapp-icon-small" />
                  <span>Escríbenos por WhatsApp</span>
                </button>
              </div>
            </div>
          </div>
          
          <div className="contact-items-social">
            <h2 className="contact-items-social-txt">¡Síguenos en nuestras redes sociales!</h2>
            <ul className="contact-items-social-links">
              <li><a href="https://www.facebook.com/investiperu" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
              <li><a href="https://www.tiktok.com/@investiperu" target="_blank" rel="noopener noreferrer"><FaTiktok /></a></li>
              <li><a href="https://www.instagram.com/investiperu/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a></li>
              <li><a href="https://www.linkedin.com/company/invest%C3%ADeirl/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a></li>
            </ul>
          </div>
        </div>
        
        {/* Formulario de Contacto (Derecha) */}
        <div className="contact-items-form">
          <form ref={form} onSubmit={handleSubmit}>
          <h2>Envíanos un mensaje</h2>
          <div className="contact-items-form-Inputbox">
            <input type="text" name="nombre" required />
            <span>Nombre completo</span>
          </div>
          <div className="contact-items-form-Inputbox">
            <input type="email" name="email" required />
            <span>Correo electrónico</span>
          </div>
          <div className="contact-items-form-Inputbox">
            <input type="tel" name="telefono" required />
            <span>Teléfono</span>
          </div>
          <div className="contact-items-form-Inputbox">
            <input type="text" name="carrera" required />
            <span>Carrera Profesional</span>
          </div>
          <div className="contact-items-form-Inputbox">
            <textarea name="message" required rows="4"></textarea>
            <span>Tu mensaje</span>
          </div>
          <div className="contact-items-form-Inputbox">
            <input type="submit" value="Enviar mensaje" />
          </div>
          </form>
        </div>
        <a
          href="https://wa.me/51961867761"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-circle whatsapp-btn-inicio"
        >
          <img
            src={logoWhatsapp}
            alt="WhatsApp"
            className="whatsapp-icon-inicio"
          />
        </a>
      </div>
    </section>
  );
}

export default Contacto;
